import styled from 'styled-components';
import { UserAvatar } from 'src/components/userAvatar';
import { limitLines } from 'src/styles';

export const Wrapper = styled.div`
  height: 6.625rem;
`;

Wrapper.displayName = 'Wrapper';

export const AvatarWrapper = styled.div`
  width: 4.75rem;
  height: 4.75rem;
`;

AvatarWrapper.displayName = 'AvatarWrapper';

export const Avatar = styled(UserAvatar)`
  width: 4.75rem;
  height: 4.75rem;
  font-size: var(--text-7);
`;

Avatar.displayName = 'Avatar';

export const UserName = styled.div`
  ${limitLines(3)}
  font-size: 1.125rem;
`;

UserName.displayName = 'UserName';
